import React, { useState, useEffect } from 'react'
import Logo from '../common/Logo'

// ─── Palette ─────────────────────────────────────────────────────────────────
const C = {
  blue:     '#2563EB',
  blueDark: '#1D4ED8',
  blueLight:'#EFF6FF',
  bg:       '#F8FAFC',
  text:     '#1E293B',
  muted:    '#64748B',
  border:   '#E2E8F0',
  white:    '#FFFFFF',
}

// ─── Dashboard SVG Mockup ────────────────────────────────────────────────────
function DashboardMockup() {
  return (
    <svg viewBox="0 0 560 360" xmlns="http://www.w3.org/2000/svg"
      style={{ width: '100%', borderRadius: 16, boxShadow: '0 24px 64px rgba(37,99,235,0.18)', display: 'block' }}>
      {/* Fond */}
      <rect width="560" height="360" rx="16" fill="#F1F5F9"/>

      {/* Sidebar */}
      <rect width="140" height="360" rx="0" fill="#1E293B"/>
      <rect x="0" width="140" height="360" rx="16" fill="#1E293B"/>
      <rect x="136" width="4" height="360" fill="#1E293B"/>

      {/* Logo sidebar */}
      <rect x="16" y="20" width="108" height="28" rx="6" fill={C.blue}/>
      <text x="70" y="39" textAnchor="middle" fontSize="11" fontWeight="800" fill="white">Suiveo BTP</text>

      {/* Nav items */}
      {[['Tableau de bord', true], ['Chantiers', false], ['Tâches', false], ['Documents', false], ['Messages', false]].map(([label, active], i) => (
        <g key={i}>
          <rect x="8" y={68 + i * 38} width="124" height="28" rx="6"
            fill={active ? C.blue : 'transparent'} opacity={active ? 1 : 0.6}/>
          <rect x="20" y={78 + i * 38} width="8" height="8" rx="2"
            fill={active ? 'white' : 'rgba(255,255,255,0.5)'}/>
          <text x="34" y={86 + i * 38} fontSize="9" fontWeight={active ? 700 : 400}
            fill={active ? 'white' : 'rgba(255,255,255,0.6)'}>{label}</text>
        </g>
      ))}

      {/* Header zone */}
      <rect x="148" y="12" width="400" height="36" rx="8" fill="white"/>
      <text x="164" y="35" fontSize="11" fontWeight="700" fill={C.text}>Tableau de bord</text>
      <rect x="472" y="18" width="68" height="24" rx="6" fill={C.blue}/>
      <text x="506" y="34" textAnchor="middle" fontSize="8" fontWeight="700" fill="white">+ Chantier</text>

      {/* KPI cards */}
      {[
        ['5', 'Chantiers', C.blue,    148],
        ['12', 'Tâches', '#7C3AED',   268],
        ['74%', 'Avancement', '#059669', 388],
      ].map(([val, label, color, x], i) => (
        <g key={i}>
          <rect x={x} y="60" width="112" height="56" rx="10" fill="white"
            filter="drop-shadow(0 2px 8px rgba(0,0,0,0.06))"/>
          <text x={x + 56} y="88" textAnchor="middle" fontSize="22" fontWeight="900" fill={color}>{val}</text>
          <text x={x + 56} y="104" textAnchor="middle" fontSize="8" fill={C.muted}>{label}</text>
        </g>
      ))}

      {/* Chantier list */}
      <rect x="148" y="128" width="240" height="220" rx="10" fill="white"
        filter="drop-shadow(0 2px 8px rgba(0,0,0,0.06))"/>
      <text x="164" y="150" fontSize="10" fontWeight="700" fill={C.text}>Chantiers en cours</text>
      {[
        ['Villa Les Pins — Mougins', 74, '#059669'],
        ['Appt Haussmann — Paris', 38, C.blue],
        ['Maison Dupont — Toulouse', 12, '#F59E0B'],
      ].map(([name, pct, color], i) => (
        <g key={i}>
          <text x="164" y={172 + i * 56} fontSize="8" fontWeight="600" fill={C.text}>{name}</text>
          <rect x="164" y={178 + i * 56} width="192" height="6" rx="3" fill="#F1F5F9"/>
          <rect x="164" y={178 + i * 56} width={192 * pct / 100} height="6" rx="3" fill={color}/>
          <text x="364" y={186 + i * 56} textAnchor="end" fontSize="8" fontWeight="700" fill={color}>{pct}%</text>
          <rect x="164" y={192 + i * 56} width={[100,60,140][i]} height="4" rx="2" fill="#F1F5F9"/>
        </g>
      ))}

      {/* Tasks panel */}
      <rect x="400" y="128" width="148" height="220" rx="10" fill="white"
        filter="drop-shadow(0 2px 8px rgba(0,0,0,0.06))"/>
      <text x="416" y="150" fontSize="10" fontWeight="700" fill={C.text}>Tâches récentes</text>
      {[
        ['Démolition', '#059669', '#ECFDF5'],
        ['Plomberie', C.blue, '#EFF6FF'],
        ['Carrelage', '#F59E0B', '#FFFBEB'],
        ['Peinture', '#94A3B8', '#F8FAFC'],
      ].map(([label, col, bg], i) => (
        <g key={i}>
          <rect x="408" y={160 + i * 44} width="132" height="32" rx="6" fill={bg}/>
          <circle cx="420" cy={176 + i * 44} r="4" fill={col}/>
          <text x="430" y={180 + i * 44} fontSize="8" fontWeight="500" fill={C.text}>{label}</text>
        </g>
      ))}
    </svg>
  )
}

// ─── Icônes SVG inline ────────────────────────────────────────────────────────
function IconEmail() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="24" fill="#FEF2F2"/>
      <rect x="12" y="16" width="24" height="17" rx="3" stroke="#EF4444" strokeWidth="2" fill="none"/>
      <path d="M12 19l12 8 12-8" stroke="#EF4444" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  )
}
function IconFolder() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="24" fill="#FFF7ED"/>
      <path d="M13 20h22v13a2 2 0 01-2 2H15a2 2 0 01-2-2V20z" stroke="#F97316" strokeWidth="2" fill="none"/>
      <path d="M13 20v-2a2 2 0 012-2h6l2 3H13z" stroke="#F97316" strokeWidth="2" fill="none"/>
    </svg>
  )
}
function IconEye() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="24" fill="#F5F3FF"/>
      <ellipse cx="24" cy="24" rx="11" ry="7" stroke="#7C3AED" strokeWidth="2" fill="none"/>
      <circle cx="24" cy="24" r="3" stroke="#7C3AED" strokeWidth="2" fill="none"/>
      <path d="M13 24s3-7 11-7 11 7 11 7" stroke="#7C3AED" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  )
}

// ─── Section wrapper ──────────────────────────────────────────────────────────
function Section({ id, children, style = {} }) {
  return (
    <section id={id} style={{ padding: '96px 24px', ...style }}>
      {children}
    </section>
  )
}

function Container({ children, style = {} }) {
  return (
    <div style={{ maxWidth: 1120, margin: '0 auto', ...style }}>
      {children}
    </div>
  )
}

// ─── Accordion FAQ ────────────────────────────────────────────────────────────
function FaqItem({ question, answer }) {
  const [open, setOpen] = useState(false)
  return (
    <div style={{
      background: C.white, borderRadius: 12, border: `1.5px solid ${open ? C.blue : C.border}`,
      marginBottom: 12, overflow: 'hidden',
      transition: 'border-color 0.2s',
      boxShadow: open ? `0 4px 16px rgba(37,99,235,0.08)` : 'none',
    }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '20px 24px', background: 'none', border: 'none', cursor: 'pointer',
          textAlign: 'left', gap: 16,
        }}
      >
        <span style={{ fontSize: 16, fontWeight: 600, color: C.text }}>{question}</span>
        <span style={{
          flexShrink: 0, width: 28, height: 28, borderRadius: '50%',
          background: open ? C.blue : C.blueLight,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'background 0.2s, transform 0.2s',
          transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
        }}>
          <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
            <path d="M1 1.5l5 5 5-5" stroke={open ? 'white' : C.blue} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      </button>
      {open && (
        <div style={{ padding: '0 24px 20px', fontSize: 15, color: C.muted, lineHeight: 1.7 }}>
          {answer}
        </div>
      )}
    </div>
  )
}

// ─── Main Component ───────────────────────────────────────────────────────────
export default function LandingPage({ onShowLogin, onShowRegister, onShowMentions, onShowCGV, onShowRGPD, onShowCGU }) {

  // Ombre navbar au scroll
  const [scrolled, setScrolled] = useState(false)
  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 10)
    window.addEventListener('scroll', handler)
    return () => window.removeEventListener('scroll', handler)
  }, [])

  const scrollTo = (id) => {
    const el = document.getElementById(id)
    if (el) el.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif', color: C.text, overflowX: 'hidden', background: C.white }}>

      {/* ─────────────────────────────── STYLES GLOBAUX ────────────────────── */}
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        html { scroll-behavior: smooth; }
        .lp-btn-primary {
          background: ${C.blue}; color: white; border: none; border-radius: 10px;
          padding: 14px 28px; font-size: 15px; font-weight: 700; cursor: pointer;
          transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
          box-shadow: 0 4px 16px rgba(37,99,235,0.3);
        }
        .lp-btn-primary:hover {
          background: ${C.blueDark}; transform: translateY(-1px);
          box-shadow: 0 8px 24px rgba(37,99,235,0.35);
        }
        .lp-btn-secondary {
          background: white; color: ${C.blue}; border: 2px solid ${C.blue}; border-radius: 10px;
          padding: 14px 28px; font-size: 15px; font-weight: 600; cursor: pointer;
          transition: background 0.2s, color 0.2s;
        }
        .lp-btn-secondary:hover { background: ${C.blueLight}; }
        .lp-feature-card {
          background: white; border-radius: 14px; padding: 28px 24px;
          border: 1.5px solid ${C.border};
          transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        }
        .lp-feature-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(37,99,235,0.12);
          border-color: ${C.blue};
        }
        .lp-step-num {
          width: 56px; height: 56px; border-radius: 50%;
          background: ${C.blue}; color: white;
          display: flex; align-items: center; justify-content: center;
          font-size: 22px; font-weight: 800; margin: 0 auto 20px;
          box-shadow: 0 0 0 8px rgba(37,99,235,0.1);
        }
        @media (max-width: 900px) {
          .lp-hero-grid { grid-template-columns: 1fr !important; }
          .lp-features-grid { grid-template-columns: 1fr 1fr !important; }
          .lp-steps-grid { grid-template-columns: 1fr !important; }
          .lp-problem-grid { grid-template-columns: 1fr !important; }
          .lp-footer-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 600px) {
          .lp-features-grid { grid-template-columns: 1fr !important; }
          .lp-hero-h1 { font-size: 36px !important; }
          .lp-section-h2 { font-size: 28px !important; }
          .lp-footer-grid { grid-template-columns: 1fr !important; }
          .lp-nav-cta { display: none !important; }
        }
      `}</style>

      {/* ─────────────────────────────── NAVBAR ──────────────────────────── */}
      <nav style={{
        position: 'sticky', top: 0, zIndex: 200,
        background: 'rgba(255,255,255,0.97)',
        backdropFilter: 'blur(12px)',
        borderBottom: `1px solid ${scrolled ? C.border : 'transparent'}`,
        boxShadow: scrolled ? '0 2px 16px rgba(0,0,0,0.08)' : 'none',
        transition: 'box-shadow 0.3s, border-color 0.3s',
        padding: '0 24px', height: 68,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 40 }}>
          <Logo size="md" withText={true} />
          <div style={{ display: 'flex', gap: 28 }} className="lp-nav-cta">
            {[['Fonctionnalités','features'],['Tarifs','pricing'],['FAQ','faq']].map(([label, id]) => (
              <button key={id} onClick={() => scrollTo(id)} style={{
                background: 'none', border: 'none', color: C.muted,
                fontSize: 14, fontWeight: 500, cursor: 'pointer', padding: '4px 0',
                transition: 'color 0.15s',
              }}
                onMouseEnter={e => e.target.style.color = C.text}
                onMouseLeave={e => e.target.style.color = C.muted}
              >{label}</button>
            ))}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button onClick={onShowLogin} style={{
            background: 'none', border: `1.5px solid ${C.border}`, borderRadius: 8,
            padding: '8px 18px', fontSize: 14, fontWeight: 500, cursor: 'pointer', color: C.text,
            transition: 'border-color 0.2s',
          }}
            onMouseEnter={e => e.target.style.borderColor = C.blue}
            onMouseLeave={e => e.target.style.borderColor = C.border}
          >Se connecter</button>
          <button onClick={onShowRegister} className="lp-btn-primary" style={{ padding: '8px 18px', fontSize: 14 }}>
            Essai gratuit
          </button>
        </div>
      </nav>

      {/* ─────────────────────────────── HERO ───────────────────────────── */}
      <section style={{
        background: `linear-gradient(135deg, #EFF6FF 0%, #F8FAFC 50%, #F0F9FF 100%)`,
        padding: '100px 24px 80px',
        borderBottom: `1px solid ${C.border}`,
      }}>
        <Container>
          <div className="lp-hero-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64, alignItems: 'center' }}>
            {/* Texte */}
            <div>
              {/* Badge social proof */}
              <div style={{
                display: 'inline-flex', alignItems: 'center', gap: 8,
                background: 'white', border: `1.5px solid ${C.border}`,
                borderRadius: 24, padding: '6px 16px', marginBottom: 28,
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              }}>
                <span style={{ fontSize: 14 }}>⭐</span>
                <span style={{ fontSize: 13, color: C.muted, fontWeight: 500 }}>
                  Déjà utilisé par des équipes BTP en France
                </span>
              </div>

              <h1 className="lp-hero-h1" style={{
                fontSize: 52, fontWeight: 900, lineHeight: 1.08,
                marginBottom: 24, color: C.text, letterSpacing: '-0.02em',
              }}>
                Suivez vos chantiers.<br />
                <span style={{ color: C.blue }}>Partout.</span>{' '}
                <span style={{ color: C.blue }}>En temps réel.</span>
              </h1>

              <p style={{ fontSize: 18, color: C.muted, lineHeight: 1.75, marginBottom: 40, maxWidth: 500 }}>
                Suiveo BTP centralise les rapports, les documents et la communication entre architectes, entreprises et clients — sur un seul tableau de bord.
              </p>

              <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
                <button onClick={onShowRegister} className="lp-btn-primary" style={{ fontSize: 16, padding: '15px 32px' }}>
                  Commencer gratuitement
                </button>
                <button onClick={() => scrollTo('how')} className="lp-btn-secondary" style={{ fontSize: 16, padding: '15px 32px' }}>
                  Voir une démo →
                </button>
              </div>

              <div style={{ marginTop: 28, display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
                {['Gratuit pendant la bêta', 'Accès complet sans carte', 'Support inclus'].map((text, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: C.muted }}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <circle cx="7" cy="7" r="7" fill="#DCFCE7"/>
                      <path d="M4 7l2 2 4-4" stroke="#16A34A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {text}
                  </div>
                ))}
              </div>
            </div>

            {/* Mockup */}
            <div style={{ position: 'relative' }}>
              <div style={{
                position: 'absolute', inset: -20,
                background: `radial-gradient(ellipse at 60% 40%, rgba(37,99,235,0.12) 0%, transparent 70%)`,
                borderRadius: 32, zIndex: 0,
              }}/>
              <div style={{ position: 'relative', zIndex: 1 }}>
                <DashboardMockup />
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* ─────────────────────────────── PROBLÈME ───────────────────────── */}
      <Section style={{ background: C.bg }}>
        <Container>
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <p style={{ fontSize: 13, fontWeight: 700, color: C.blue, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 12 }}>Le problème</p>
            <h2 className="lp-section-h2" style={{ fontSize: 36, fontWeight: 800, color: C.text, marginBottom: 16 }}>
              Vous reconnaissez ces situations ?
            </h2>
            <p style={{ fontSize: 17, color: C.muted, maxWidth: 520, margin: '0 auto' }}>
              Le chantier avance, mais la communication et l'organisation, elles, restent en retard.
            </p>
          </div>
          <div className="lp-problem-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 28 }}>
            {[
              { icon: <IconEmail />, titre: 'Rapports perdus dans les emails', desc: 'Les comptes-rendus de visite sont éparpillés dans des fils d\'email sans fin. Retrouver une information prend du temps et crée des erreurs.' },
              { icon: <IconFolder />, titre: 'Documents éparpillés partout', desc: 'Plans, DICT, PPSPS, devis... Sur Dropbox, par email, sur clé USB. Personne ne sait quelle est la dernière version.' },
              { icon: <IconEye />, titre: 'Pas de visibilité sur l\'avancement', desc: 'Le client rappelle tous les trois jours. L\'architecte jongle entre les mises à jour de chaque entreprise. Personne n\'a la même information.' },
            ].map((item, i) => (
              <div key={i} style={{
                background: C.white, borderRadius: 16, padding: '36px 28px',
                border: `1.5px solid ${C.border}`,
                boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
                textAlign: 'center',
              }}>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>{item.icon}</div>
                <div style={{ fontSize: 17, fontWeight: 700, color: C.text, marginBottom: 12 }}>{item.titre}</div>
                <div style={{ fontSize: 14, color: C.muted, lineHeight: 1.7 }}>{item.desc}</div>
              </div>
            ))}
          </div>
          {/* Flèche vers solution */}
          <div style={{ textAlign: 'center', marginTop: 52 }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 10,
              background: C.blue, color: 'white', borderRadius: 40,
              padding: '12px 28px', fontSize: 15, fontWeight: 700,
              boxShadow: '0 4px 16px rgba(37,99,235,0.25)',
            }}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="8" fill="rgba(255,255,255,0.2)"/>
                <path d="M5 8h6M8 5l3 3-3 3" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Suiveo BTP résout tout ça en un seul outil
            </div>
          </div>
        </Container>
      </Section>

      {/* ─────────────────────────────── FONCTIONNALITÉS ─────────────────── */}
      <Section id="features" style={{ background: C.white }}>
        <Container>
          <div style={{ textAlign: 'center', marginBottom: 60 }}>
            <p style={{ fontSize: 13, fontWeight: 700, color: C.blue, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 12 }}>Fonctionnalités</p>
            <h2 className="lp-section-h2" style={{ fontSize: 36, fontWeight: 800, color: C.text, marginBottom: 16 }}>
              Tout ce dont votre équipe a besoin
            </h2>
            <p style={{ fontSize: 17, color: C.muted, maxWidth: 540, margin: '0 auto' }}>
              Conçu pour les professionnels du bâtiment. Simple pour tout le monde.
            </p>
          </div>
          <div className="lp-features-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
            {[
              { emoji: '📋', titre: 'Rapports journaliers', desc: 'Créez et partagez vos rapports de chantier en quelques clics. Exportez en PDF en un instant.', color: '#EFF6FF' },
              { emoji: '📁', titre: 'Gestion documentaire', desc: 'Centralisez plans, DICT, PPSPS et toute la doc chantier jusqu\'à 50 Mo par fichier, accessible partout.', color: '#FFF7ED' },
              { emoji: '👥', titre: 'Multi-acteurs', desc: 'Architectes, entreprises et clients sur le même projet. Chaque rôle a son interface dédiée.', color: '#F5F3FF' },
              { emoji: '📊', titre: 'Tableau de bord', desc: 'Visualisez l\'avancement de chaque chantier en temps réel. Tâches, progression, alertes.', color: '#F0FDF4' },
              { emoji: '🔔', titre: 'Alertes & notifications', desc: 'Restez informé en temps réel. Nouvelles tâches, documents ajoutés, messages de l\'équipe.', color: '#FEF2F2' },
              { emoji: '📱', titre: 'Accessible partout', desc: 'Interface 100% responsive. Ordinateur, tablette, mobile — votre chantier vous suit sur tous vos appareils.', color: '#ECFDF5' },
            ].map((f, i) => (
              <div key={i} className="lp-feature-card">
                <div style={{
                  width: 52, height: 52, borderRadius: 14, background: f.color,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 26, marginBottom: 18,
                }}>{f.emoji}</div>
                <div style={{ fontSize: 17, fontWeight: 700, color: C.text, marginBottom: 10 }}>{f.titre}</div>
                <div style={{ fontSize: 14, color: C.muted, lineHeight: 1.7 }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </Container>
      </Section>

      {/* ─────────────────────────────── COMMENT ÇA MARCHE ───────────────── */}
      <Section id="how" style={{ background: `linear-gradient(135deg, #1E293B 0%, #0F172A 100%)` }}>
        <Container>
          <div style={{ textAlign: 'center', marginBottom: 64 }}>
            <p style={{ fontSize: 13, fontWeight: 700, color: '#60A5FA', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 12 }}>En 3 étapes</p>
            <h2 className="lp-section-h2" style={{ fontSize: 36, fontWeight: 800, color: 'white', marginBottom: 16 }}>
              Comment ça marche ?
            </h2>
            <p style={{ fontSize: 17, color: '#94A3B8', maxWidth: 480, margin: '0 auto' }}>
              Opérationnel en moins de 5 minutes, sans formation requise.
            </p>
          </div>
          <div className="lp-steps-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 48, position: 'relative' }}>
            {/* Ligne de connexion */}
            <div style={{
              position: 'absolute', top: 28, left: '22%', right: '22%', height: 2,
              background: 'linear-gradient(90deg, rgba(37,99,235,0.8), rgba(37,99,235,0.2))',
              zIndex: 0,
            }} className="lp-nav-cta"/>
            {[
              { num: '1', emoji: '🏗️', titre: 'Créez votre compte', desc: 'Inscrivez-vous en 2 minutes. Créez votre premier chantier et configurez les intervenants. C\'est immédiatement prêt.' },
              { num: '2', emoji: '👷', titre: 'Invitez votre équipe', desc: 'Ajoutez vos entreprises par email. Chaque intervenant accède à son espace dédié avec ses tâches et documents.' },
              { num: '3', emoji: '📡', titre: 'Suivez vos chantiers', desc: 'L\'architecte pilote tout depuis son dashboard. Le client reçoit un code unique pour consulter l\'avancement sans créer de compte.' },
            ].map((step, i) => (
              <div key={i} style={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
                <div className="lp-step-num">{step.num}</div>
                <div style={{ fontSize: 36, marginBottom: 16 }}>{step.emoji}</div>
                <div style={{ fontSize: 18, fontWeight: 700, color: 'white', marginBottom: 12 }}>{step.titre}</div>
                <div style={{ fontSize: 14, color: '#94A3B8', lineHeight: 1.8 }}>{step.desc}</div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 56 }}>
            <button onClick={onShowRegister} className="lp-btn-primary" style={{ fontSize: 16, padding: '15px 36px' }}>
              Commencer maintenant — c'est gratuit
            </button>
          </div>
        </Container>
      </Section>

      {/* ─────────────────────────────── TARIFS ──────────────────────────── */}
      <Section id="pricing" style={{ background: C.bg }}>
        <Container>
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <p style={{ fontSize: 13, fontWeight: 700, color: C.blue, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 12 }}>Tarifs</p>
            <h2 className="lp-section-h2" style={{ fontSize: 36, fontWeight: 800, color: C.text, marginBottom: 16 }}>
              Un seul plan. Tout inclus.
            </h2>
            <p style={{ fontSize: 17, color: C.muted }}>Sans surprise, sans engagement, sans carte requise pour démarrer.</p>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{
              background: C.white, borderRadius: 24, padding: '48px 48px',
              maxWidth: 480, width: '100%',
              border: `2px solid ${C.blue}`,
              boxShadow: '0 20px 60px rgba(37,99,235,0.15)',
              position: 'relative', textAlign: 'center',
            }}>
              {/* Badge recommandé */}
              <div style={{
                position: 'absolute', top: -16, left: '50%', transform: 'translateX(-50%)',
                background: C.blue, color: 'white', borderRadius: 24,
                padding: '5px 20px', fontSize: 12, fontWeight: 800,
                whiteSpace: 'nowrap', letterSpacing: '0.5px',
              }}>⭐ LE PLUS POPULAIRE</div>

              <div style={{ fontSize: 52, marginBottom: 8 }}>🏗️</div>
              <div style={{ fontSize: 22, fontWeight: 800, color: C.text, marginBottom: 4 }}>Suiveo BTP Pro</div>
              <div style={{ fontSize: 15, color: C.muted, marginBottom: 28 }}>Pour architectes, MOE et chefs de projet</div>

              {/* Prix */}
              <div style={{ marginBottom: 8 }}>
                <span style={{ fontSize: 64, fontWeight: 900, color: '#16A34A', lineHeight: 1 }}>Gratuit</span>
              </div>
              <div style={{ fontSize: 14, color: C.muted, marginBottom: 8 }}>
                Pendant la période bêta — <strong style={{ color: '#16A34A' }}>aucune carte requise</strong>
              </div>
              <div style={{ fontSize: 13, color: C.muted, marginBottom: 28, background: '#F0FDF4', borderRadius: 8, padding: '8px 12px' }}>
                Prix de lancement prévu à <strong>20€/mois</strong> après la bêta
              </div>

              {/* Liste features */}
              <div style={{ textAlign: 'left', marginBottom: 36 }}>
                {[
                  'Chantiers illimités',
                  'Rapports journaliers illimités',
                  'Gestion documentaire — jusqu\'à 50 Mo/fichier',
                  'Multi-acteurs : entreprises & clients',
                  'Tableau de bord temps réel',
                  'Alertes & notifications',
                  'Messagerie interne intégrée',
                  'Accès client sans inscription (code unique)',
                  'Export PDF des comptes-rendus',
                  'Support email prioritaire',
                  'Mises à jour incluses',
                ].map((feature, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 12 }}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ flexShrink: 0, marginTop: 2 }}>
                      <circle cx="9" cy="9" r="9" fill="#DBEAFE"/>
                      <path d="M5.5 9l2.5 2.5 5-5" stroke={C.blue} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span style={{ fontSize: 14, color: C.text, lineHeight: 1.5 }}>{feature}</span>
                  </div>
                ))}
              </div>

              <button onClick={onShowRegister} className="lp-btn-primary" style={{ width: '100%', padding: '16px 0', fontSize: 16 }}>
                Créer mon compte gratuitement
              </button>

              <p style={{ marginTop: 16, fontSize: 13, color: C.muted }}>
                Accès complet · Aucune carte bancaire · Résiliation à tout moment
              </p>
            </div>
          </div>
        </Container>
      </Section>

      {/* ─────────────────────────────── BETA CONTACT ───────────────────── */}
      <Section style={{ background: '#F0FDF4', paddingTop: 48, paddingBottom: 48 }}>
        <Container>
          <div style={{
            background: 'white', borderRadius: 16, padding: '32px 40px',
            border: '2px solid #BBF7D0', textAlign: 'center',
            maxWidth: 620, margin: '0 auto',
          }}>
            <div style={{ fontSize: 36, marginBottom: 12 }}>💬</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#15803D', marginBottom: 8 }}>
              Vous testez la version bêta ?
            </div>
            <p style={{ fontSize: 15, color: '#4B5563', marginBottom: 20, lineHeight: 1.6 }}>
              Bug, idée d'amélioration, fonctionnalité manquante — votre retour compte vraiment.
              Écrivez-nous directement, on répond à tous les messages.
            </p>
            <a
              href="mailto:suiveo.btp@gmail.com?subject=Retour bêta Suiveo BTP"
              style={{
                display: 'inline-block',
                background: '#16A34A', color: 'white',
                padding: '14px 32px', borderRadius: 10,
                fontWeight: 700, fontSize: 15, textDecoration: 'none',
              }}
            >
              Envoyer un retour → suiveo.btp@gmail.com
            </a>
          </div>
        </Container>
      </Section>

      {/* ─────────────────────────────── FAQ ─────────────────────────────── */}
      <Section id="faq" style={{ background: C.white }}>
        <Container>
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <p style={{ fontSize: 13, fontWeight: 700, color: C.blue, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 12 }}>FAQ</p>
            <h2 className="lp-section-h2" style={{ fontSize: 36, fontWeight: 800, color: C.text, marginBottom: 16 }}>
              Questions fréquentes
            </h2>
            <p style={{ fontSize: 17, color: C.muted }}>Tout ce que vous voulez savoir avant de vous lancer.</p>
          </div>
          <div style={{ maxWidth: 720, margin: '0 auto' }}>
            {[
              {
                question: 'Puis-je annuler à tout moment ?',
                answer: 'Oui, vous pouvez résilier votre abonnement en un clic depuis votre espace personnel, sans justification ni pénalité. L\'accès reste actif jusqu\'à la fin de la période déjà payée.',
              },
              {
                question: 'Combien de chantiers puis-je gérer ?',
                answer: 'Illimité. Aucun plafond sur le nombre de chantiers, d\'entreprises invitées, de documents uploadés ou de rapports générés. Vous utilisez autant que vous avez besoin.',
              },
              {
                question: 'Mes données sont-elles sécurisées ?',
                answer: 'Vos données sont hébergées en Europe (infrastructure Supabase), chiffrées en transit et au repos. Vous restez propriétaire de vos données à tout moment.',
              },
              {
                question: "Y a-t-il une période d'essai ?",
                answer: 'Oui ! Utilisez le code promo TEST-GRATUIT lors de votre inscription pour bénéficier de 30 jours offerts, sans carte bancaire requise. Vous découvrez toutes les fonctionnalités sans engagement.',
              },
              {
                question: 'Ça fonctionne sur mobile ?',
                answer: 'Oui, Suiveo BTP est 100% responsive. L\'interface est optimisée pour ordinateur, tablette et smartphone. Vous et vos équipes pouvez l\'utiliser directement depuis le chantier.',
              },
            ].map((item, i) => (
              <FaqItem key={i} question={item.question} answer={item.answer} />
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 40 }}>
            <p style={{ fontSize: 14, color: C.muted }}>
              Vous avez une autre question ?{' '}
              <a href="mailto:suiveo.btp@gmail.com" style={{ color: C.blue, fontWeight: 600, textDecoration: 'none' }}>
                Écrivez-nous →
              </a>
            </p>
          </div>
        </Container>
      </Section>

      {/* ─────────────────────────────── CTA FINAL ───────────────────────── */}
      <section style={{
        background: `linear-gradient(135deg, ${C.blue} 0%, #1D4ED8 100%)`,
        padding: '96px 24px',
        textAlign: 'center',
      }}>
        <Container>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(255,255,255,0.15)',
            borderRadius: 24, padding: '6px 16px', marginBottom: 28,
          }}>
            <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.9)', fontWeight: 500 }}>
              ⭐ Déjà utilisé par des équipes BTP en France
            </span>
          </div>
          <h2 style={{ fontSize: 42, fontWeight: 900, color: 'white', marginBottom: 20, letterSpacing: '-0.02em' }}>
            Prêt à digitaliser<br />vos chantiers ?
          </h2>
          <p style={{ fontSize: 18, color: 'rgba(255,255,255,0.8)', marginBottom: 44, maxWidth: 500, margin: '0 auto 44px' }}>
            Rejoignez des professionnels du bâtiment qui utilisent Suiveo BTP au quotidien.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 14, flexWrap: 'wrap' }}>
            <button onClick={onShowRegister} style={{
              background: 'white', color: C.blue, border: 'none', borderRadius: 12,
              padding: '16px 36px', fontSize: 16, fontWeight: 800, cursor: 'pointer',
              boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
              transition: 'transform 0.15s, box-shadow 0.15s',
            }}
              onMouseEnter={e => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 12px 32px rgba(0,0,0,0.25)' }}
              onMouseLeave={e => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 8px 24px rgba(0,0,0,0.2)' }}
            >
              Commencer gratuitement
            </button>
            <button onClick={onShowLogin} style={{
              background: 'rgba(255,255,255,0.15)', color: 'white',
              border: '2px solid rgba(255,255,255,0.4)', borderRadius: 12,
              padding: '16px 36px', fontSize: 16, fontWeight: 600, cursor: 'pointer',
              transition: 'background 0.2s',
            }}
              onMouseEnter={e => e.target.style.background = 'rgba(255,255,255,0.25)'}
              onMouseLeave={e => e.target.style.background = 'rgba(255,255,255,0.15)'}
            >
              Se connecter
            </button>
          </div>
        </Container>
      </section>

      {/* ─────────────────────────────── FOOTER ─────────────────────────── */}
      <footer style={{ background: '#0F172A', padding: '60px 24px 32px', color: '#94A3B8' }}>
        <Container>
          <div className="lp-footer-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 40, marginBottom: 48 }}>
            {/* Brand */}
            <div>
              <Logo size="sm" withText={true} textColor="white" />
              <p style={{ fontSize: 14, color: '#64748B', marginTop: 16, lineHeight: 1.7, maxWidth: 280 }}>
                La plateforme collaborative de suivi de chantier pour architectes, entreprises et clients.
              </p>
              <div style={{ marginTop: 20 }}>
                <a href="mailto:suiveo.btp@gmail.com" style={{
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                  color: '#64748B', fontSize: 13, textDecoration: 'none',
                  transition: 'color 0.15s',
                }}
                  onMouseEnter={e => e.target.style.color = 'white'}
                  onMouseLeave={e => e.target.style.color = '#64748B'}
                >
                  ✉️ suiveo.btp@gmail.com
                </a>
              </div>
            </div>

            {/* Produit */}
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#E2E8F0', marginBottom: 16, textTransform: 'uppercase', letterSpacing: '1px' }}>Produit</div>
              {[
                { label: 'Se connecter', fn: onShowLogin },
                { label: 'Créer un compte', fn: onShowRegister },
                { label: 'Fonctionnalités', fn: () => scrollTo('features') },
                { label: 'Tarifs', fn: () => scrollTo('pricing') },
              ].map((l, i) => (
                <button key={i} onClick={l.fn} style={{
                  display: 'block', background: 'none', border: 'none', color: '#64748B',
                  cursor: 'pointer', fontSize: 14, padding: '5px 0', textAlign: 'left',
                  transition: 'color 0.15s',
                }}
                  onMouseEnter={e => e.target.style.color = 'white'}
                  onMouseLeave={e => e.target.style.color = '#64748B'}
                >{l.label}</button>
              ))}
            </div>

            {/* Légal */}
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#E2E8F0', marginBottom: 16, textTransform: 'uppercase', letterSpacing: '1px' }}>Légal</div>
              {[
                { label: 'Mentions légales', fn: onShowMentions },
                { label: 'CGU', fn: onShowCGU },
                { label: 'CGV', fn: onShowCGV },
                { label: 'Politique RGPD', fn: onShowRGPD },
              ].map((l, i) => (
                <button key={i} onClick={l.fn} style={{
                  display: 'block', background: 'none', border: 'none', color: '#64748B',
                  cursor: 'pointer', fontSize: 14, padding: '5px 0', textAlign: 'left',
                  transition: 'color 0.15s',
                }}
                  onMouseEnter={e => e.target.style.color = 'white'}
                  onMouseLeave={e => e.target.style.color = '#64748B'}
                >{l.label}</button>
              ))}
            </div>

            {/* Aide */}
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#E2E8F0', marginBottom: 16, textTransform: 'uppercase', letterSpacing: '1px' }}>Aide</div>
              <p style={{ fontSize: 14, color: '#64748B', lineHeight: 1.7 }}>
                Une question ?<br />
                <a href="mailto:suiveo.btp@gmail.com" style={{ color: C.blue, textDecoration: 'none', fontWeight: 500 }}>
                  Contactez-nous
                </a>
              </p>
              <div style={{ marginTop: 20 }}>
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                  background: 'rgba(37,99,235,0.15)', borderRadius: 8, padding: '6px 12px',
                }}>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#4ADE80', display: 'inline-block' }}/>
                  <span style={{ fontSize: 12, color: '#94A3B8' }}>Disponible en France</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bas de footer */}
          <div style={{
            paddingTop: 24, borderTop: '1px solid #1E293B',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            flexWrap: 'wrap', gap: 12,
          }}>
            <div style={{ fontSize: 13, color: '#475569' }}>
              © 2025 Suiveo BTP — Tous droits réservés
            </div>
            <div style={{ fontSize: 12, color: '#334155' }}>
              Fait avec ❤️ pour les professionnels du bâtiment
            </div>
          </div>
        </Container>
      </footer>

    </div>
  )
}
